// extracted by css-extract-rspack-plugin
export default {"orderContent":"orderContent-nqAD2m","order":"order-kyN9h8","exchangeRateProgressBar":"exchangeRateProgressBar-PLVwHx"};